import React from "react";

import { useInput } from "../../../hooks/useInput";
import { Checkbox } from "../../../components/Checkbox";
import { useOnChange } from "../../../hooks/useOnChange";
import { InputNumber } from "../../../components/InputNumber";

export const SectorForm = props => {
    const { index, sector, updateDirection, updateHeight } = props;

    const no = index + 1;
    const selected = useInput("selected-" + no, sector.selected);
    const height = useInput("height-" + no, sector.height);
    const direction = useInput("direction-" + no, sector.direction);
    const mechDowntilt = useInput("mechDowntilt-" + no, sector.mechDowntilt);

    useOnChange((name, value) => {
        const [column] = name.split("-");
        sector[column] = value;
    }, [selected, mechDowntilt]);

    const handleDirectionChange = value => {
        sector.direction = value;
        if (index === 0) {
            updateDirection(value);
        }
    };

    const handleHeightChange = value => {
        sector.height = value;
        if (index === 0) {
            updateHeight(value);
        }
    };

    return (
        <>
            <Checkbox {...selected.bind} title={false} />
            <InputNumber {...height.bind} title={false} fractionDigits={2} onChange={handleHeightChange} />
            <InputNumber {...direction.bind} title={false} fractionDigits={2} onChange={handleDirectionChange} />
            <InputNumber {...mechDowntilt.bind} title={false} fractionDigits={2} />
        </>
    );
};